<template>
  <span class="faux-form">
    <select
      ref="input"
      class
      v-bind:value="dataValue"
      v-on:change="onChange"
      v-on:keydown="onKeyDownListener"
      v-on:keyup="onKeyUpListener"
      v-bind:required="question.required"
    >
      <option
        v-if="question.required"
        label=" "
        value=""
        disabled
        selected
        hidden
        >&nbsp;</option
      >
      <option
        v-for="(option, index) in question.options"
        v-bind:disabled="option.disabled"
        v-bind:value="option.choiceValue()"
        v-bind:key="'o' + index"
      >
        {{ option.choiceValue() }}
      </option>
    </select>
    <span>
      <span
        class="f-empty"
        v-bind:class="{
          'f-answered': this.question.answer && this.question.answered
        }"
        >{{ answerLabel }}</span
      >
      <span class="f-arrow-down">
        <svg
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M10 0.5H0L5 5.5L10 0.5Z" fill="#606977" />
        </svg>
      </span>
    </span>
  </span>
</template>

<script>
import BaseType from "./BaseType.vue";
import { QuestionType } from "../../models/QuestionModel";

export default {
  extends: BaseType,
  name: QuestionType.Dropdown,
  computed: {
    answerLabel() {
      for (let i = 0; i < this.question.options.length; i++) {
        let option = this.question.options[i];

        if (option.choiceValue() === this.dataValue) {
          return option.choiceLabel();
        }
      }

      return this.question.placeholder ?? "Silahkan pilih";
    }
  },
  methods: {
    onKeyDownListener($event) {
      if ($event.key === "ArrowDown" || $event.key === "ArrowUp") {
        this.setAnswer(this.dataValue);
      } else if ($event.key === "Enter" && this.hasValue) {
        this.focused = false;
        this.blur();
      }
    },
    onKeyUpListener($event) {
      if ($event.key === "Enter" && this.isValid()) {
        $event.stopPropagation();
        this._onEnter();
        this.$emit("next");
      }
    }
  }
};
</script>
